































import { Vue, Component } from 'vue-property-decorator';
import FirebaseUtil from '@/model/FirebaseUtil';
import { COLLECTION_USERS } from '@/model/AppConstants';

@Component({
  components: {},
})
export default class UserFriends extends Vue {
  mounted() {
    this.$store.dispatch('bindUserFriends', this.user.uid);
  }

  showUserProfile(uid: any) {
    this.$router.push(`/userProfile/${uid}`);
    this.$forceUpdate();
  }

  get frnds() {
    return this.$store.state.userProfileFriends;
  }

  get user() {
    return this.$store.state.profileUser;
  }
}
